export function printBarcodes({ barcodeHtml, quantity = 1, data = {}, options = {} }) {
  if (!barcodeHtml) {
    alert('Barcode not generated yet!');
    return;
  }
  quantity = parseInt(quantity) || 1;

  const printWindow = window.open('','width=600,height=400');

  if (!printWindow) {
    alert('Popup blocked! Please allow popups for this site.');
    return;
  }

  let baseHeight = 0.6;
  if (options.show_company) baseHeight += 0.15;
  if (options.show_product) baseHeight += 0.1;
  if (options.show_price) baseHeight += 0.1;

  let content = '';
  for (let i = 0; i < quantity; i++) {
    content += `
      <div class="page">
            <div class="label"> 
              ${options.show_company && data.company_name ? `<div class="store">${data.company_name || ''}</div>` : ''} 
              ${options.show_product && data.name ? `<div class="product">${data.name || ''}</div>` : ''} 
              <div class="barcode">${barcodeHtml}</div>
              <div class="sku">${data.barcode_sku || ''}</div>
              ${options.show_price && data.description && data.description.sales_price ? `<div class="price">MRP: ${data.description.sales_price}</div>` : ''} 
            </div>
    </div>
    `;
  }

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Print Barcode</title>
        <meta charset="utf-8" />
        <style>
          @page {
            size: 1.5in ${baseHeight}in;
            margin: 0;
          }

          body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
          }

          .page {
            width: 1.5in;
            height: ${baseHeight}in;
            display: flex;
            align-items: center;
            justify-content: center; 
            box-sizing: border-box;
          }
          .page:not(:last-child) {
            page-break-after: always;
          }

          .label {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          
          .store {
            font-size: 9px;
            text-align: center; 
          }
          
          .product {
            font-size: 7px;
            margin-bottom:2px;
            padding-bottom: 2px;
          } 
          
          .barcode svg {
            width: 100%;
            height: auto;
          }
          
          .sku {
            font-size: 7px;
            letter-spacing: 2px;
            padding-bottom: 1px;
          }
          
          .price {
            font-size: 8px;
          }
        </style>
      </head>
      <body>
        ${content}
      </body>
    </html>
  `);

  printWindow.document.close();

  const waitForLoad = setInterval(() => {
    if (printWindow.document.readyState === 'complete') {
      clearInterval(waitForLoad);
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }
  }, 100);
}